import { CampaignDTO, CampaignStorage } from 'src/common/interfaces/campaigns';

export const CAMPAIGN_STORAGE_KEY = 'thm_campaigns';

const defaultStorageData: CampaignStorage = {
  activeCampaign: null,
  seenCampaigns: [],
};

export const readStoredCampaigns = (): CampaignStorage => {
  try {
    const stored = localStorage.getItem(CAMPAIGN_STORAGE_KEY) || '';
    return (JSON.parse(stored) as CampaignStorage) || defaultStorageData;
  } catch {
    return defaultStorageData;
  }
};

export const storeCampaigns = (campaigns: CampaignStorage) => {
  localStorage.setItem(CAMPAIGN_STORAGE_KEY, JSON.stringify(campaigns));
};

export const setActiveCampaign = (campaign: CampaignDTO) => {
  storeCampaigns({
    ...readStoredCampaigns(),
    activeCampaign: {
      name: campaign.name,
      sessionExpiration: Date.now() + campaign.sessionExpiration!,
    },
  });
};
